(ns app.front.view.group.admin.templates.language-selector
  (:require [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.subs :as gas]
            [clojure.set :as set]
            [core.front.event :refer [<sub]]
            [core.front.i18n :as i18n]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::disabled-locales
  :<- [::i18n/locales]
  :<- [::gas/allowed-locales]
  (fn [[all allowed] _]
    (set/difference (set (keys all)) allowed)))

(rf/reg-sub ::all-locales
  :<- [::i18n/locales]
  :-> keys)

(rf/reg-sub ::show-selector?
  :<- [::gas/allowed-locales]
  (fn [allowed-locales _]
    (-> allowed-locales count (> 1))))

(defn language-selector
  "Language selector for a template, only works under group admin pages"
  [{:keys [id language on-change]}]
  (let [tr (<sub [:tr])]
    [ui-select/select
     {:id              (str "template-lang-" id)
      :label-text      (tr [:template-editor/select-language])
      :on-change       on-change
      :value           language
      :disabled-values (<sub [::disabled-locales])
      :values          (<sub [::all-locales])
      :val->str        name}]))
